import styled from "styled-components";
export const Subsription = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const NewsLetter = styled.div`
  width: 450px;
  height: 150px;
  // border: 1px solid black;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  @media screen and (max-width: 480px) {
    width: 280px;
    height: 130px;
  }
`;
export const Top = styled.div`
  text-align: center;
  font-size: 26px;
  margin-top: 15px;
  @media screen and (max-width: 480px) {
    font-size: 15px;
  }
`;
export const Sub = styled.div`
  text-align: center;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 300;
  @media screen and (max-width: 480px) {
    font-size: 10px;
  }
`;
export const Bottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Subscribe = styled.form`
  @media screen and (max-width: 480px) {
    display: flex;
    align-items: center;
  }
`;

export const Button = styled.button`
  height: 36px;
  width: 75px;
  border: none;
  background-color: #2f3133;
  color: white;
  border-radius: 0 5px 5px 0;
  @media screen and (max-width: 480px) {
    height: 26px;
    width: 57px;
    font-size: 9px;
  }
`;

export const Input = styled.input`
  width: 280px;
  height: 36px;
  outline: none;
  @media screen and (max-width: 480px) {
    width: 144px;
    height: 26px;
    font-size: 11px;
  }
`;

export const Done = styled.p`
  text-align: center;
  margin: "5px";
  @media screen and (max-width: 480px) {
    font-size: 10px;
  }
`;
